export class Outro {

    private elm: HTMLElement;
    private imagePaths: string[];
    private imageElements: HTMLElement[];
    private isLooping: boolean;

    constructor() {
        // Initialize the main element
        this.elm = document.querySelector('.section5-content') as HTMLElement;

        // Define the image paths
        this.imagePaths = [
            './assets/textures/p1.png',
            './assets/textures/p2.png',
            './assets/textures/p3.png'
        ];

        // Prepare image elements in place of the text elements
        this.imageElements = this.imagePaths.map((path, index) => {
            let wrapElement = this.elm.querySelector(`.section5-text-wrap:nth-child(${index + 1})`) as HTMLElement;
            if (wrapElement) {
                wrapElement.style.backgroundImage = `url(${path})`;
                wrapElement.style.backgroundSize = 'cover';
                wrapElement.style.backgroundPosition = 'center';
                wrapElement.style.opacity = '0';
                wrapElement.style.transition = 'opacity 2s';  // Adjusted for both fade-in and fade-out
            }
            return wrapElement;
        });

        this.isLooping = false;  // Initialize looping flag
    }

    private timeoutList: number[] = [];

    public switchVisibility(visible: boolean) {
        // Clear any previous timeouts
        this.timeoutList.forEach(timeout => {
            window.clearTimeout(timeout);
        });

        if (visible) {
            this.isLooping = true;  // Start looping
            this.startLooping();

        } else {
            this.isLooping = false;  // Stop looping
            // Immediately hide all images
            this.imageElements.forEach(imageElement => {
                imageElement.style.opacity = '0';
            });
        }
    }

    private startLooping() {
        if (!this.isLooping) return;

        let waitSum = 0.0;

        // Show images one by one
        this.imageElements.forEach((imageElement, index) => {
            this.timeoutList.push(window.setTimeout(() => {
                imageElement.style.opacity = '1';  // Fade in to full opacity
            }, waitSum));

            this.timeoutList.push(window.setTimeout(() => {
                imageElement.style.opacity = '0';  // Then fade out to transparency
            }, waitSum + 2000));  // 2 seconds after fade-in starts, begin fade-out

            waitSum += 4000;  // Total of 4 seconds per image (2s fade-in + 2s fade-out)
        });

        // Set timeout to restart the loop after all images have gone through their sequence
        this.timeoutList.push(window.setTimeout(() => {
            this.startLooping();
        }, waitSum));  // Restart the loop after the last image has faded out
    }
}
